<div ng-controller="interactionHostController as ctrl" class="interaction-host">
    <div class="modal-view">
        <c-auto-form config="ctrl.autoFormConfig"></c-auto-form>
    </div>
</div>